import type {ReactElement} from 'react';
import {hexToRgb, PMW_COLORS_NEUTRAL, rgbToHexString} from '@Utils/color.util';
import {Circle} from '@Components/circular-progress/components/circle/circle';
import {cleanPercentage} from '@Components/circular-progress/components/circle/circle.helper';

interface CircularProgressProps {
  className?: string;
  value: number;
}

export function CircularProgress({className = '', ...props}: CircularProgressProps): ReactElement<any> {
  const STROKE_WIDTH = 3;
  const CIRCLE_DIAMETER = 16;

  return (
    <svg className={className} width={CIRCLE_DIAMETER} height={CIRCLE_DIAMETER}>
      <g transform={`rotate(-90 ${CIRCLE_DIAMETER / 2} ${CIRCLE_DIAMETER / 2})`}>
        <Circle percentage={cleanPercentage(100)} strokeWidth={STROKE_WIDTH} circleDiameter={CIRCLE_DIAMETER} color={rgbToHexString(hexToRgb(PMW_COLORS_NEUTRAL.NEUTRAL_0), 0.4)} />
        <Circle percentage={cleanPercentage(props.value)} strokeWidth={STROKE_WIDTH} circleDiameter={CIRCLE_DIAMETER} color={PMW_COLORS_NEUTRAL.NEUTRAL_0} />
      </g>
    </svg>
  );
}
